import React from "react";

const TaskLegend = ({ role }) => {
  return (
    <div className="p-4 bg-gray-50 border-t flex gap-6 justify-center flex-wrap">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 bg-blue-100 border-2 border-blue-400 rounded"></div>
        <span className="text-sm text-gray-700">Today</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 bg-green-200 border border-green-300 rounded"></div>
        <span className="text-sm text-gray-700">
          {role === "employee" ? "You Have Task" : "Has Tasks"}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 bg-red-50 border border-red-200 rounded"></div>
        <span className="text-sm text-gray-700">
          {role === "employee"
            ? "Missing Task (Past Date)"
            : "No Task (Past Date)"}
        </span>
      </div>
      {role === "employee" && (
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-orange-200 border border-orange-300 rounded"></div>
          <span className="text-sm text-gray-700">On Leave</span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 bg-white border border-gray-200 rounded hover:bg-indigo-50"></div>
        <span className="text-sm text-gray-700">
          Click to{" "}
          {role === "employee" ? "Add/Edit Your Task" : "Add/Edit Task"}
        </span>
      </div>
    </div>
  );
};

export default TaskLegend;
